import React, { useState, useEffect } from "react";
import CategoriesFull from "../Component/CategoriesFull";
import { Grid, Typography, Container, Box } from "@mui/material";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import SubFooter from "../Component/SubFooter";
import axios from "axios";
import config from "../config";
import { useParams } from "react-router-dom";

function CategoryDetail() {
  const [categoryList, setCategoryList] = useState([]);
  const { id } = useParams();
  /* eslint-disable */
  useEffect(() => {
    axios
      .get(`${config.url}/products?product_category=${id}`, config.token)
      .then((res) => {
        setCategoryList(res.data.data);
      });
  }, []);

  return (
    <React.Fragment>
      <Header />
      <Container
        maxWidth="xl"
        sx={{ mt: "30x", mb: "30px", minHeight: "60vh", height: "auto" }}
      >
        <Grid container sx={{ pt: "20px", textAlign: "center" }}>
          <Grid item xs={1} />
          <Grid item xs={10} container>
            <Grid item xs={12} sx={{ mb: "30px" }}>
              <Box>
                <Typography variant="h5" fontWeight={"bold"}>
                  {categoryList[0]?.product_category?.name}
                </Typography>
              </Box>
            </Grid>
            {/* <Grid item xs={12}> */}

            {categoryList.map((isValue, idx) => (
              <Grid item sm={6} lg={6} key={idx}>
                <CategoriesFull data={isValue} />
              </Grid>
            ))}

            {/* </Grid> */}
          </Grid>
          <Grid item xs={1} />
        </Grid>
      </Container>
      <Footer />
      <SubFooter />
    </React.Fragment>
  );
}

export default CategoryDetail;
